import React, { useEffect, useState } from "react";
import "./Size.css";
import LuversUnit from "./LuversUnit";
import html2canvas from "html2canvas";
import { relative } from "path";
const Size = React.forwardRef<HTMLInputElement, any>((props, ref) => {
  const [innerWidth, setInnerWidth] = useState(0);
  const [innerLength, setInnerLength] = useState(0);
  const [positionTop, setPositionTOp] = useState(0);
  const [positionLeft, setPositionLeft] = useState(0);
  const [viewport_width, setViewPortWidth] = React.useState(window.innerWidth);

  let drawHeight = 340,
    drawLenght = 670;
  useEffect(() => {
    window.addEventListener("resize", () =>
      setViewPortWidth(window.innerWidth)
    );
  }, []);
  if (viewport_width <= 1150) {
    drawHeight = 240;
    drawLenght = 470;
  }
  if (viewport_width <= 768) {
    drawHeight = 100;
    drawLenght = 230;
  }
  console.log(viewport_width);
  useEffect(() => {
    var el = document.querySelector(".Preloader") as HTMLElement;
    if (el != undefined) {
      el.style.display = "none";
    }

    const sizeEl = document.querySelector(".Select-area") as HTMLElement;
    if (sizeEl !== null) {
      setTimeout(() => {
        html2canvas(sizeEl).then((canvas) => {
          props.screenshotHadle(canvas.toDataURL());
        });
      }, 300);
    }
  }, [
    props.konfigured["width"],
    props.konfigured["length"],
    props.konfigured["top_luvers_count"],
    props.konfigured["bottom_luvers_count"],
    props.konfigured["left_luvers_count"],
    props.konfigured["right_luvers_count"],
    props.konfigured["top_luvers_distance"],
    props.konfigured["bottom_luvers_distance"],
    props.konfigured["left_luvers_distance"],
    props.konfigured["right_luvers_distance"],
    props.konfigured["window_width"],
    props.konfigured["window_length"],
  ]);

  useEffect(() => {
    setInnerLength(
      drawWindow(
        props.konfigured["length"],
        props.konfigured["window_length"],
        drawLenght
      )
    );
    setInnerWidth(
      drawWindow(
        props.konfigured["width"],
        props.konfigured["window_width"],
        drawHeight
      )
    );
  }, [
    props.konfigured["window_width"],
    props.konfigured["window_length"],
    viewport_width,
  ]);

  useEffect(() => {
    const position = drawWindowPosition(
      Number(props.konfigured["top_window_distace"]),
      Number(props.konfigured["left_window_distace"]),
      Number(props.konfigured["width"]),
      Number(props.konfigured["length"]),
      drawHeight,
      drawLenght
    );
    setPositionTOp((position.top.position && position.top.position()) || 0);
    setPositionLeft((position.left.position && position.left.position()) || 0);
  }, [
    props.konfigured["top_window_distace"],
    props.konfigured["right_window_distace"],
    props.konfigured["bottom_window_distace"],
    props.konfigured["left_window_distace"],
    viewport_width,
  ]);

  useEffect(() => {
    const arrow_angle = document.querySelectorAll('.arrow-angle') as NodeList
    arrow_angle.forEach((el: any) => {
      if (props.konfigured.top_left_angle > 0 ) {
        el.style.transform = "skewY(10deg)";
        el.style.opacity = "1";
      }
      if (props.konfigured.top_right_angle> 0 ) {
        el.style.transform = "skewY(-10deg)";
        el.style.opacity = "1";
      }
      if (+props.konfigured.top_right_angle === 0  && +props.konfigured.top_left_angle === 0) {
        el.style.opacity = "0";
      }
    })
   
   
    
  }, [props.konfigured.top_right_angle, props.konfigured.top_left_angle])

  const drawWindow = (full_value: number, cut_value: number, ratio: number) => {
    const percent = (cut_value / full_value) * 100;
    const result = (ratio / 100) * percent;
    return result;
  };

  const drawWindowPosition = (
    top: number,
    left: number,
    width: number,
    length: number,
    ratio_width: number,
    ratio_length: number
  ) => {
    const result: {
      top: { percent: number; position?: () => number };
      left: { percent: number; position?: () => number };
    } = {
      top: { percent: 0, position: undefined },
      left: { percent: 0, position: undefined },
    };

    result.top = {
      percent: (top / width) * 100,
      position: function () {
        return (ratio_width / 100) * this.percent;
      },
    };
    result.left = {
      percent: (left / length) * 100,
      position: function () {
        return (ratio_length / 100) * this.percent;
      },
    };

    return result;
  };

  //ui position
  // const positionWindow = () => {
  //   props.konfigured["left_window_distace"]
  // }

  const sizeShowCase = {
    background: `${props.color}`,
    color: `#f5f5f5`,
    height: `${drawHeight}px`,
    width: `${drawLenght}px`,
  };

  const hideInnerWindow = {
    opacity: 1,
  };
  if (props.konfigured["window_width"] && props.konfigured["window_length"]) {
    hideInnerWindow.opacity = 1;
  } else {
    hideInnerWindow.opacity = 0;
  }

  let sizeOfElement = 60;
  if (viewport_width <= 768) {
    sizeOfElement = 35;
  }

  const padding = 0;

  const sizeLines = {
    sizeLineWidth: {
      width: drawLenght - innerLength - positionLeft + sizeOfElement + "px",
      right: -(drawLenght - innerLength - positionLeft + sizeOfElement) + "px",
    },
    sizeLineLength: {
      height: positionTop + sizeOfElement + "px",
      top: -(positionTop + sizeOfElement) + "px",
    },
  };

  const sizeArrows = {
    sizeLineWidth: {
      height: positionTop,
      right: `${padding}px`,
    },
    sizeLineLength: {
      width: positionLeft,
      right:
        -(drawLenght - innerLength - positionLeft + sizeOfElement * 2) + "px",
    },
    sizeLineLengthRight: {
      width: drawLenght - innerLength - positionLeft,
      left: 0,
    },
    sizeLineWidthBottom: {
      height: drawHeight - innerWidth - positionTop,
      right: `${padding}px`,
    },
  };

  const innerStyle = {
    height: `${innerWidth}px`,
    width: `${innerLength}px`,
    transition: `all 300ms cubic-bezier(.075,.82,.165,1);`,
    top: positionTop + "px",
    left: positionLeft + "px",
  };

  let bottomLineStyle = {};
  let leftLineStyle = {};
  let rightLineStyle = {};

  const renderLuvers = function (count: number, unit: string, side = false) {
    let hideStyle = {};
    if (unit) unit = unit.toString();

    if (side) {
      count = count + 1;
      if (props.konfigured["bottom_luvers_count"] > 0) {
        count = count + 1;
        hideStyle = {
          opacity: 0,
        };
      }
    }
    try {
      return new Array(count)
        .fill("")
        .map((el, i, arr) => (
          <LuversUnit
            hideStyle={i === arr.length - 1 ? hideStyle : {}}
            unit={unit}
          ></LuversUnit>
        ));
    } catch {
      console.log("There is no luvers count yet");
    }
  };

  // Handle center of align line
  if (props.konfigured["top_luvers"] === 3) {
    leftLineStyle = { left: "28px" };
    rightLineStyle = { right: "28px" };
  }
  if (props.konfigured["right_luvers"] === 3) {
    bottomLineStyle = { bottom: "28px" };
  }
  return (
    <div className="Size">
      
      <div
        style={{
          height: "120px",
          left: 0,
          top: "-120px"
        }}
        className="long-arrow arrow-angle vertical"
      >
        <div className="long-arrow-inner">
          <div className="arrow up"></div>
          <div className="arrow-text-box">
            <div className="arrow-text small">{props.konfigured.top_left_angle || props.konfigured.top_right_angle}</div>
          </div>
          <div className="arrow-body"></div>
          <div className="arrow down"></div>
        </div>
      </div>
      <div
          style={{
            width: `${drawLenght}px`,
            top: "-120px",
            position: "absolute",
          }}
          className="long-arrow horisontal arrow-angle"
        >
          <div className="long-arrow-inner">
            <div className="arrow left"></div>
            <div className="arrow-text-box">
              <div className="arrow-text small">{props.konfigured.hypotenuse ? props.konfigured.hypotenuse.toFixed(1): 0}</div>
            </div>
            <div className="arrow-body"></div>
            <div className="arrow right"></div>
          </div>
        </div>
      <div
        style={{ width: `${drawLenght}px`, background: `${props.color}` }}
        className={[
          "Size-angle ",
          props.konfigured.top_left_angle > 0 ? "left-angle " : "",
          props.konfigured.top_right_angle > 0 ? "right-angle " : "",
          props.konfigured.top_right_angle === 0  && props.konfigured.top_right_angle === 0 ? "hidden ": "", 
        ].join(" ")}
      >
        <div className="Size-angle-top-left"></div>
        <div className="Size-angle-top-right"></div>
      </div>
      <div
        style={{
          height: "100%",
          left: 0,
        }}
        className="long-arrow vertical"
      >
        <div className="long-arrow-inner">
          <div className="arrow up"></div>
          <div className="arrow-text-box">
            <div className="arrow-text small">{props.konfigured.width}</div>
          </div>
          <div className="arrow-body"></div>
          <div className="arrow down"></div>
        </div>
      </div>
      <div
        style={hideInnerWindow}
        className="showcase-line-size showcase-line-size-left"
      ></div>
      <div
        style={hideInnerWindow}
        className="showcase-line-size showcase-line-size-right"
      ></div>
      <div
        style={hideInnerWindow}
        className="showcase-line-size showcase-line-size-top"
      ></div>
      <div
        style={hideInnerWindow}
        className="showcase-line-size showcase-line-size-bottom"
      ></div>
      <div className="Size-showcase" style={sizeShowCase}>
        {props.konfigured["window"] !== "bez_okna" ? (
          <div
            style={{ ...innerStyle, ...hideInnerWindow }}
            className="Size-window"
          >
            <div className="Size-window-inner">
              <div
                style={sizeLines.sizeLineWidth}
                className="window-distace top-window-distace"
              >
                {props.konfigured["top_window_distace"]}
                <div
                  style={{
                    ...sizeArrows.sizeLineWidth,
                    top: -positionTop + "px",
                  }}
                  className="long-arrow vertical"
                >
                  <div className="long-arrow-inner">
                    <div className="arrow up"></div>
                    <div className="arrow-text-box">
                      <div className="arrow-text small">
                        {props.konfigured.top_window_distace}
                      </div>
                    </div>
                    <div className="arrow-body"></div>
                    <div className="arrow down"></div>
                  </div>
                </div>
                <div
                  style={{
                    ...sizeArrows.sizeLineWidth,
                    height: innerWidth + "px",
                    top: 0,
                  }}
                  className="long-arrow vertical"
                >
                  <div className="long-arrow-inner">
                    <div className="arrow up"></div>
                    <div className="arrow-text-box">
                      <div className="arrow-text small">
                        {props.konfigured.top_window_distace}
                      </div>
                    </div>
                    <div className="arrow-body"></div>
                    <div className="arrow down"></div>
                  </div>
                </div>
              </div>
              <div
                style={sizeLines.sizeLineLength}
                className="window-distace right-window-distace"
              >
                <div
                  style={{
                    ...sizeArrows.sizeLineLengthRight,
                    top: 0,
                    right: -positionLeft,
                  }}
                  className="long-arrow horisontal"
                >
                  <div className="long-arrow-inner">
                    <div className="arrow left"></div>
                    <div className="arrow-text-box">
                      <div className="arrow-text small">
                        {props.konfigured["right_window_distace"]}
                      </div>
                    </div>
                    <div className="arrow-body"></div>
                    <div className="arrow right"></div>
                  </div>
                </div>
              </div>
              <div
                style={sizeLines.sizeLineLength}
                className="window-distace left-window-distace"
              >
                <div
                  style={{
                    ...sizeArrows.sizeLineLength,
                    top: 0,
                    left: -positionLeft,
                  }}
                  className="long-arrow horisontal"
                >
                  <div className="long-arrow-inner">
                    <div className="arrow left"></div>
                    <div className="arrow-text-box">
                      <div className="arrow-text small">
                        {props.konfigured["left_window_distace"]}
                      </div>
                    </div>
                    <div className="arrow-body"></div>
                    <div className="arrow right"></div>
                  </div>
                </div>

                <div
                  style={{
                    ...sizeArrows.sizeLineLength,
                    top: 0,
                    width: innerLength,
                    left: 0,
                  }}
                  className="long-arrow horisontal"
                >
                  <div className="long-arrow-inner">
                    <div className="arrow left"></div>
                    <div className="arrow-text-box">
                      <div className="arrow-text small">
                        {props.konfigured["window_width"]}
                      </div>
                    </div>
                    <div className="arrow-body"></div>
                    <div className="arrow right"></div>
                  </div>
                </div>
              </div>
              <div
                style={sizeLines.sizeLineWidth}
                className="window-distace bottom-window-distace"
              >
                {props.konfigured["bottom_window_distace"]}
                <div
                  style={{ ...sizeArrows.sizeLineWidthBottom }}
                  className="long-arrow vertical"
                >
                  <div className="long-arrow-inner">
                    <div className="arrow up"></div>
                    <div className="arrow-text-box">
                      <div className="arrow-text small">
                        {props.konfigured.bottom_window_distace}
                      </div>
                    </div>
                    <div className="arrow-body"></div>
                    <div className="arrow down"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
        <div className="showcase-distance showcase-distance-top">
          <div className="arrows small">
            <i className="gg-arrow-long-right gg-arrow-long-left"></i>
            <span className="arrows-text-bottom arrows-text">
              {" "}
              {props.konfigured["top_luvers_distance"]}{" "}
            </span>
            <i className="gg-arrow-long-right"></i>
          </div>
        </div>
        <div className="showcase-distance showcase-distance-right">
          <div className="arrows small">
            <i className="gg-arrow-long-right gg-arrow-long-left"></i>
            <span className="arrows-text-bottom arrows-text">
              {" "}
              {props.konfigured["right_luvers_distance"]}{" "}
            </span>
            <i className="gg-arrow-long-right"></i>
          </div>
        </div>
        <div className="showcase-distance showcase-distance-left">
          <div className="arrows small">
            <i className="gg-arrow-long-right gg-arrow-long-left"></i>
            <span className="arrows-text-bottom arrows-text">
              {" "}
              {props.konfigured["left_luvers_distance"]}{" "}
            </span>
            <i className="gg-arrow-long-right"></i>
          </div>
        </div>
        <div className="showcase-distance showcase-distance-bottom">
          <div className="arrows small">
            <i className="gg-arrow-long-right gg-arrow-long-left"></i>
            <span className="arrows-text-bottom arrows-text">
              {" "}
              {props.konfigured["bottom_luvers_distance"]}{" "}
            </span>
            <i className="gg-arrow-long-right"></i>
          </div>
        </div>
        <div className="showcase-line showcase-line-top">
          <div className="showcase-line-inner">
            {renderLuvers(
              +props.konfigured["top_luvers_count"],
              props.konfigured["top_luvers"]
            )}
          </div>
        </div>
        <div
          className="showcase-line showcase-line-right"
          style={rightLineStyle}
        >
          <div className="showcase-line-inner">
            {renderLuvers(
              +props.konfigured["right_luvers_count"],
              props.konfigured["right_luvers"],
              true
            )}
          </div>
        </div>
        <div className="showcase-line showcase-line-left" style={leftLineStyle}>
          <div className="showcase-line-inner">
            {renderLuvers(
              +props.konfigured["left_luvers_count"],
              props.konfigured["left_luvers"],
              true
            )}
          </div>
        </div>
        <div
          className="showcase-line showcase-line-bottom"
          style={bottomLineStyle}
        >
          <div className="showcase-line-inner">
            {renderLuvers(
              +props.konfigured["bottom_luvers_count"],
              props.konfigured["bottom_luvers"]
            )}
          </div>
        </div>
      </div>
      <div
        style={{
          width: "100%",
          position: "static",
        }}
        className="long-arrow horisontal"
      >
        <div className="long-arrow-inner">
          <div className="arrow left"></div>
          <div className="arrow-text-box">
            <div className="arrow-text small">{props.konfigured.length}</div>
          </div>
          <div className="arrow-body"></div>
          <div className="arrow right"></div>
        </div>
      </div>
    </div>
  );
});

export default Size;
